"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DozukiHeader = exports.NAV_HEIGHT = exports.HEADER_HEIGHT = exports.Z_INDEX = void 0;
var React = __importStar(require("react"));
var react_1 = require("react");
var react_2 = require("@chakra-ui/react");
var SiteLogo_1 = require("./components/SiteLogo");
var useHeaderProps_1 = require("./hooks/useHeaderProps");
var MainNavLinks_1 = require("./components/MainNavLinks");
var CreateMenu_1 = require("./components/CreateMenu");
var ToolBar_1 = require("./components/ToolBar");
var colors_1 = require("./colors");
exports.Z_INDEX = 9;
exports.HEADER_HEIGHT = '50px';
exports.NAV_HEIGHT = 50;
var DozukiHeader = function (_a) {
    var _b = _a.LinkComponent, LinkComponent = _b === void 0 ? react_2.Link : _b, siteLogoUrl = _a.siteLogoUrl, siteTitle = _a.siteTitle, siteConfiguration = _a.siteConfiguration, colorSet = _a.colorSet, permissions = _a.permissions, toast = _a.toast, _js = _a._js, onResourceCenterSelected = _a.onResourceCenterSelected, props = __rest(_a, ["LinkComponent", "siteLogoUrl", "siteTitle", "siteConfiguration", "colorSet", "permissions", "toast", "_js", "onResourceCenterSelected"]);
    var breakpoint = (0, react_2.useBreakpointValue)({ base: 'base', md: 'md', fallback: 'md' });
    var _c = React.useState(true), isPreRendering = _c[0], setIsPreRendering = _c[1];
    React.useEffect(function () {
        setIsPreRendering(false);
    }, []);
    var parsedColorSet = (0, react_1.useMemo)(function () { return colorSet !== null && colorSet !== void 0 ? colorSet : (0, colors_1.getColorSetFromConfiguration)(siteConfiguration); }, [colorSet, siteConfiguration]);
    var effectiveInstalledApps = (0, react_1.useMemo)(function () {
        var apps = [];
        if ((siteConfiguration === null || siteConfiguration === void 0 ? void 0 : siteConfiguration['feature-creator-pro']) && (permissions === null || permissions === void 0 ? void 0 : permissions.canIViewCreatorPro)) {
            apps.push({
                appKey: 'creator-pro',
                route: '/Apps/CreatorPro',
                name: _js('CreatorPro'),
            });
        }
        if ((siteConfiguration === null || siteConfiguration === void 0 ? void 0 : siteConfiguration['feature-qr-code-generator']) && (permissions === null || permissions === void 0 ? void 0 : permissions.canIGenerateQRCode)) {
            apps.push({
                appKey: 'qr-code-generator',
                route: '/Apps/QRGenerator',
                name: _js('QR Code Generator'),
            });
        }
        return apps.length > 0 ? apps : undefined;
    }, [siteConfiguration]);
    var headerProps = (0, react_1.useMemo)(function () { return (__assign(__assign({ LinkComponent: LinkComponent, siteLogoUrl: siteLogoUrl, siteTitle: siteTitle, siteConfiguration: siteConfiguration, toast: toast, colorSet: parsedColorSet, permissions: permissions, onResourceCenterSelected: onResourceCenterSelected }, props), { _js: _js, installedApps: effectiveInstalledApps })); }, [
        LinkComponent,
        siteLogoUrl,
        siteTitle,
        siteConfiguration,
        toast,
        parsedColorSet,
        permissions,
        onResourceCenterSelected,
        props,
        effectiveInstalledApps,
    ]);
    return (React.createElement(useHeaderProps_1.HeaderPropsContext.Provider, { value: headerProps },
        React.createElement(react_2.Box, { as: "header", height: exports.HEADER_HEIGHT, className: "main-header", bg: parsedColorSet.background, borderBottom: "1px ".concat(parsedColorSet.backgroundBorder, " solid"), position: "relative", zIndex: exports.Z_INDEX }, !isPreRendering && (React.createElement(react_2.Container, { as: "nav", maxW: "100%", m: 0, p: 2, h: exports.NAV_HEIGHT, className: "main-nav" },
            React.createElement(react_2.Flex, { align: "center", justify: "space-between", h: "100%" },
                React.createElement(react_2.Flex, { align: "center", zIndex: exports.Z_INDEX, gap: { sm: 2, xl: 4 } },
                    breakpoint === 'base' && React.createElement(MainNavLinks_1.MainNavLinks, null),
                    React.createElement(SiteLogo_1.SiteLogo, { LinkComponent: LinkComponent, url: siteLogoUrl, title: siteTitle, color: parsedColorSet.accent1 }),
                    React.createElement(react_2.Flex, { align: "center" },
                        breakpoint !== 'base' && React.createElement(MainNavLinks_1.MainNavLinks, null),
                        props.user && (permissions === null || permissions === void 0 ? void 0 : permissions.canICreateNewWikis) && (React.createElement(CreateMenu_1.CreateMenu, { toast: toast })))),
                React.createElement(ToolBar_1.ToolBar, null)))))));
};
exports.DozukiHeader = DozukiHeader;
